module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_hospital-558498f99a7d385c73cd691bd8a1c127.svg";